import { ColumnConfig } from '@/old/utils/helper';
import { useState } from 'react';
import { CommonWorkflowReportUnitData } from '@/app/components/WorkflowsReport/ReportTypes/Common';
import {
  WorklistReportDataState,
  WorklistReportSettingsConfig,
} from '@/app/components/Reporting/Collaboration/WorklistsReport/types';
import { useColumnConfigs } from '@/app/components/Reporting/Collaboration/WorklistsReport/useColumnConfigs';

export const useWorklistReportSettings = () => {
  const reportGridColumns = useColumnConfigs();

  const reportSettingConfigInit: WorklistReportSettingsConfig = {
    columns: reportGridColumns,
    dataState: { skip: 0, take: 9 },
    teamCheck: true,
    subUnitCheck: false,
    selectedUnitData: undefined,
  };

  const [columns, setColumns] = useState<ColumnConfig[]>(reportGridColumns);
  const [dataState, setDataState] = useState<WorklistReportDataState>(
    reportSettingConfigInit.dataState,
  );

  // Toolbar settings
  const [teamCheck, setTeamCheck] = useState<boolean>(
    reportSettingConfigInit.teamCheck,
  );
  const [subUnitCheck, setSubUnitCheck] = useState<boolean>(
    reportSettingConfigInit.subUnitCheck,
  );
  const [toolbarSelectedUnit, setToolbarSelectedUnit] = useState<
    CommonWorkflowReportUnitData | undefined
  >(reportSettingConfigInit.selectedUnitData);

  const reportSettingConfig: WorklistReportSettingsConfig = {
    columns,
    dataState,
    teamCheck,
    subUnitCheck,
    selectedUnitData: toolbarSelectedUnit,
  };

  return {
    reportSettings: {
      settingsType: 'worklist',
      initial: reportSettingConfigInit,
      current: reportSettingConfig,
    },
    setStates: {
      setTeamCheck,
      setSubUnitCheck,
      setSelectedUnit: setToolbarSelectedUnit,
      setColumns,
      setDataState,
    },
  };
};
